import React from 'react';
import { ConfirmDialog } from '../../../../../components/confirm-dialog';

export type ProtocolCompletionAction = 'submit' | 'submitForApproval' | 'approve';

interface IAttendanceProtocolCompletionDialogProps {
  action?: ProtocolCompletionAction;
  onConfirm: () => void;
  onCancel: () => void;
}

export function AttendanceProtocolCompletionDialog(props: IAttendanceProtocolCompletionDialogProps) {
  const { action, onConfirm, onCancel } = props;

  const locksSheet = action !== 'submitForApproval';

  return (
    <ConfirmDialog
      open={action !== undefined}
      type={locksSheet ? 'warning' : 'question'}
      title={locksSheet ? 'Godkend protokollen?' : 'Klar til godkendelse?'}
      message={
        locksSheet
          ? 'Bemærk at protokollen låses, og der ikke kan rettes yderligere i borgernes fremmøde, når protokollen er godkendt.'
          : 'Protokollen sendes til godkendelse. Der kan stadig rettes i borgernes fremmøde, indtil protokollen er godkendt.'
      }
      confirmButtonText={locksSheet ? 'Godkend' : 'Send til godkendelse'}
      cancelButtonText="Afbryd"
      onConfirmClick={onConfirm}
      onCancelClick={onCancel}
    />
  );
}
